import GeneralTranslations from "../../../Common/ModuleTranslations/en";

export default {
  locale: "en",
  name: "Bookable",
  translation: { displayName: "Translations" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "arrangement",
        displayName: "Order",
      },
      {
        fieldName: "isActive",
        displayName: "Active",
      },
      {
        fieldName: "isVisible",
        displayName: "Visible",
      },
      {
        fieldName: "name",
        displayName: "Name",
      },
      {
        fieldName: "rate",
        displayName: "Typology",
      },
      {
        fieldName: "type",
        displayName: "Use",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "isActive",
        displayName: "Active",
      },
      {
        fieldName: "isVisible",
        displayName: "Displayed",
      },
      {
        fieldName: "name",
        displayName: "Name",
      },
      {
        fieldName: "description",
        displayName: "Description",
      },
      {
        fieldName: "codesSection",
        displayName: "Company code",
        subtitle:
          "Only those users who enter this code in the booking engine can activate this promotion",
      },
    ],
  },
};
